export enum AnimalCoatType {
  SHORT = 'short',
  MEDIUM = 'medium',
  LONG = 'long',
  CURLY = 'curly',
  SHAGGY = 'shaggy',
  ROUGH = 'rough',
  SMOOTH = 'smooth',
  STICK = 'stick',
  NONE = 'none'
}